const INTERCOM_COOKIE_PREFIX = 'intercom-'
const INTERCOM_COOKIE_RESET_KEY = 'client_zone_intercom_cookie_reset_v1'

const expireCookie = (name, domain) => {
  const domainAttribute = domain ? `; Domain=${domain}` : ''
  document.cookie = `${name}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT${domainAttribute}`
}

export const clearIntercomCookies = () => {
  const hostname = window.location.hostname
  const parentDomain = hostname.split('.').slice(-2).join('.')
  const domains = new Set([null, hostname, parentDomain])
  const cookieNames = document.cookie
    .split(';')
    .map(cookie => cookie.split('=')[0].trim())
    .filter(name => name.startsWith(INTERCOM_COOKIE_PREFIX))

  for (const name of cookieNames) {
    domains.forEach(domain => expireCookie(name, domain))
  }
}

export const resetLegacyIntercomCookies = () => {
  if (localStorage.getItem(INTERCOM_COOKIE_RESET_KEY)) {
    return
  }

  clearIntercomCookies()
  localStorage.setItem(INTERCOM_COOKIE_RESET_KEY, '1')
}
